export async function getNewThread(
  assistantId: number,
  userId: number,
  contextType: "ai_assistant_card" | "vpe_chat" | "vpe_feedback" = "ai_assistant_card"
) {
  const response = await fetch(`/ai_assistant/assistants/${assistantId}/threads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement).content
    },
    body: JSON.stringify({
      ai_assistant_thread: {
        user_id: userId,
        context_type: contextType,
      }
    })
  });

  if (!response.ok) {
    // TODO: HANDLE ERROR
    throw new Error("Failed to create thread");
  }

  return response.json();
}
